<template>
  <div id="contenedor-agregar-nuevo-detalle">
    <v-form
      v-model="formularioValido"
      ref="registrarNuevoObservacionDetalle">
      <v-card>
        <v-card-title>
          Agregar Desglose de Observación {{observacion.numero}}
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <SelectAuditoriaContratos
              v-if="!observacion.idContrato"
              :multiSelect="false"
              v-on:input="inputContrato"
              cols="12">
              </SelectAuditoriaContratos>
            </v-col>
            <!-- Seleccionar contrato
            <v-col cols="12" md="12">
              <CustomSelect
              v-if="!observacion.idContrato"
              v-model="observacionDetalle.idContrato"
              label="Cotrato"
              :items="getAuditoriaContratos"
              item-text="contrato"
              item-value="id">
            </CustomSelect>
            </v-col> -->
            <v-col
              cols="12" md="12">
              <TextArea
                v-model="observacionDetalle.texto"
                label="Desglose"
                placeholder="Descripción del desglose"
                rows="3"
                :rules="[mixReglas.requerido]">
              </TextArea>
            </v-col>
            <CustomDatePicker
              v-model="observacionDetalle.fechaVencimiento"
              cols="12"
              md="6"
              label="Fecha vencimiento"
              :rules="[mixReglas.requerido]">
            </CustomDatePicker>
            <v-col
              cols="12" md="6">
            </v-col>
            <v-col>
              <TextArea
                v-model="observacionDetalle.comentarios"
                label="Comentarios"
                rows="3">
              </TextArea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
            </custom-button>
          <custom-button
            @click="guardar"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            >
            </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import TextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import SelectAuditoriaContratos from '@/components/administracion/auditorias/observaciones/AuditoriasContratosPicker.vue';
// import CustomSelect from '@/components/inputs/Select.vue';
import mixObservaciones from '../mixObservaciones';

export default {
  name: 'RegistrarNuevoDetalle',
  mixins: [mixObservaciones],
  components: {
    CustomDatePicker,
    TextArea,
    CustomButton,
    SelectAuditoriaContratos,
    // CustomSelect,
  },
  props: {
    informe: {
      type: Object,
      required: true,
    },
    observacion: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      observacionDetalle: {
        idAuditoriaObservacion: null,
        idContrato: null,
        requiereAccion: false,
        requiereDocumento: false,
        texto: '',
        fechaVencimiento: null,
        enviado: false,
        comentarios: '',
      },
    };
  },
  mounted() {
    this.calcularProponerFechaVencimiento();
  },
  methods: {
    limpiarFormularioDetalle() {
      this.$refs.registrarNuevoObservacionDetalle.reset();
      this.calcularProponerFechaVencimiento();
    },
    async guardar() {
      await this.mixAgregarAuditoriaInformeObservacionDetalle();
    },
    calcularProponerFechaVencimiento() {
      if (!this.informe.fechaVencimiento) {
        this.observacionDetalle.fechaVencimiento = new Date()
          .toISOString()
          .substring(0, 10);
        return;
      }

      const fechaVencimientoInforme = new Date(this.informe.fechaVencimiento);
      fechaVencimientoInforme.setDate(fechaVencimientoInforme.getDate() - 7);
      fechaVencimientoInforme.toISOString();

      this.observacionDetalle.fechaVencimiento = fechaVencimientoInforme
        .toISOString().substring(0, 10);
    },
    cerrar() {
      this.limpiarFormularioDetalle();
      this.$emit('cerrar');
    },
    inputContrato(contratoSeleccionado) {
      this.observacionDetalle.idContrato = contratoSeleccionado.id;
    },
  },
  computed: {
    getAuditoriaContratos() {
      if (!this.auditoriasContratos) return [];
      return this.auditoriasContratos.map((c) => ({
        contrato: c.contrato.numero,
        id: c.contrato.id,
      }));
    },
  },
  watch: {
    informe: {
      handler() {
        this.calcularProponerFechaVencimiento();
      },
    },
  },
};
</script>

<style lang="scss">

</style>
